import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 15px;

  form {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 700px;
  }
`;

export const Distributor = styled.div`
  padding: 10px;
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
`;
